var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125.996,
    height: 112.936,
    viewBox: "0 0 125.996 112.936",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_message_sent_1030",
    transform: "translate(-214.982 -146.466)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M430.643,409.092h-85.8a10.577,10.577,0,0,1-10.609-10.545V359.474a4.166,4.166,0,0,1,1.312-3.032L381.009,313.6a9.829,9.829,0,0,1,13.464,0l43.351,40.844a10.889,10.889,0,0,1,3.428,7.925v36.174A10.577,10.577,0,0,1,430.643,409.092Z",
    transform: "translate(-100.274 -149.69)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M240.954,387.992H347.085v42.875a6.407,6.407,0,0,1-6.406,6.407H247.36a6.407,6.407,0,0,1-6.406-6.407Z",
    transform: "translate(-6.999 -177.872)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M333.73,521.351",
    transform: "translate(-99.53 -313.521)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2205",
    "data-name": "Rectangle 2205",
    width: 78.925,
    height: 78.941,
    transform: "translate(247.892 176.336)",
    fill: "#fe6502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M387.241,551.466l-50.567-24.444a2.052,2.052,0,0,0-2.945,1.847v42.057a6.407,6.407,0,0,0,6.406,6.407h94.21a6.407,6.407,0,0,0,6.406-6.407V529.589a2.5,2.5,0,0,0-3.593-2.254Z",
    transform: "translate(-99.886 -318.043)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2206",
    "data-name": "Rectangle 2206",
    width: 22.077,
    height: 3.122,
    transform: "translate(254.909 183.979)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2207",
    "data-name": "Rectangle 2207",
    width: 65.561,
    height: 1.784,
    transform: "translate(253.035 195.293)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2208",
    "data-name": "Rectangle 2208",
    width: 65.561,
    height: 1.784,
    transform: "translate(253.035 201.282)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2209",
    "data-name": "Rectangle 2209",
    width: 65.561,
    height: 1.784,
    transform: "translate(253.035 207.27)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 9.143,
    cy: 9.159,
    rx: 9.143,
    ry: 9.159,
    transform: "translate(242.249 168.87)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    d: "M373.156,338.851a10.927,10.927,0,1,0,10.927,10.927A10.927,10.927,0,0,0,373.156,338.851ZM370.913,355.6l-5.6-5.6,1.571-1.571,4.035,4.035,8.516-8.516L381,345.523Z",
    transform: "translate(-121.761 -171.536)",
    fill: "#57b894",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2347",
    "data-name": "Group 2347",
    transform: "matrix(1, 0.017, -0.017, 1, 215.292, 146.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M3.68,1.328,0,7.71l26.989,4.395L9.606,0Z",
    transform: "translate(0 5.665)",
    fill: "#fe6502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M3.68,1.328,0,7.71l26.989,4.395L9.606,0Z",
    transform: "translate(0 5.665)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M4.432,0,23.309,17.77,0,6.993Z",
    transform: "translate(3.68 0)",
    fill: "#fe6502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M0,8.1l25.922.494L1.724,0Z",
    transform: "translate(0.994 9.026)",
    fill: "#fe6502"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmEmail);
export default __webpack_public_path__ + "static/media/confirm-email.046b91ade5113269fab3e275e4f8e5d2.svg";
export { ForwardRef as ReactComponent };